import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css'; // Usiamo gli stili esistenti

const NotFound = () => {
  return (
    <div className="notfound-page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
      <div className="notfound-container">
        <h1 className="titolo-404" style={{ fontSize: '6rem', color: '#ff4700' }}>404</h1>
        <h2 className="titolo-sezione">Ops! Pagina non trovata</h2>
        <p className="descrizione-hero">
          La pagina che stai cercando non esiste o è stata spostata. 
          Torna alla community per continuare a divertirti!
        </p>
        <div className="hero-buttons">
          <Link to="/" className="btn-custom-orange">Torna alla Home</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;